import { isPwaMode, useIntl } from '@capsicum/common';
import { AvailableWalletBalanceDrawer, GenericDrawer, useGoatImage, useRouter } from '@capsicum/common-web';
import {
	type FanTokenOfferingDrawerParams,
	FanTokenOfferingLimits,
	useFanTokenOfferingDrawerData
} from '@capsicum/features/fan-token-offering/shared';

export type FanTokenOfferingDrawerProps = {
	closeModal: () => void;
	drawerParams: FanTokenOfferingDrawerParams;
	testID: string;
	type: FanTokenOfferingLimits;
};

/*
 * Generate the drawer depending on the type of error/user limit
 *
 * @param {FanTokenOfferingLimits} type - the type of drawer to show
 * @param {FanTokenOfferingDrawerParams} drawerParams - params used to generate translations
 * @param {void} userBoughtQuantity - The quantity of fan token already bought by the user on this FTO
 *
 * @returns a drawer
 */
export const FanTokenOfferingDrawer = ({ closeModal, drawerParams, testID, type }: FanTokenOfferingDrawerProps) => {
	const { $t } = useIntl();
	const { push } = useRouter();
	const goatAlertImage = useGoatImage('alert');
	const isInsufficientBalance = type === FanTokenOfferingLimits.InsufficientBalance;

	const { ...drawerData } = useFanTokenOfferingDrawerData({
		...(!isInsufficientBalance && { image: goatAlertImage }),
		drawerParams,
		testID,
		type
	});

	return isInsufficientBalance ? (
		<GenericDrawer
			{...drawerData}
			secondaryActionButtonText={$t('global.button.cancel')}
			onButtonPress={() => {
				closeModal();
				push(`/wallet/topup`);
			}}
			onSecondaryActionOnButtonPress={closeModal}
		>
			<AvailableWalletBalanceDrawer
				walletBalance={drawerParams.walletBalance}
				walletCurrency={drawerParams.walletCurrencyShortCode}
			/>
		</GenericDrawer>
	) : (
		<GenericDrawer {...drawerData} isButtonFullWidth={!!isPwaMode()} onButtonPress={closeModal} />
	);
};
